import { render, staticRenderFns } from "./CertificateInformation.vue?vue&type=template&id=654df1f6&"
import script from "./CertificateInformation.vue?vue&type=script&lang=ts&"
export * from "./CertificateInformation.vue?vue&type=script&lang=ts&"
import style0 from "./CertificateInformation.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CertificateInformation.vue"
export default component.exports